/**
 * Centralized platform / environment detection for the player.
 * Use for branching on Android WebView, feature flags, etc.
 */

/** Android WebKit/WebView often misbehaves with iframe src="blob:...". */
export function isAndroidWebView(): boolean {
  if (typeof navigator === 'undefined' || !navigator.userAgent) { return false }
  return /Android/i.test(navigator.userAgent)
}

/**
 * Whether to use the Android HTML fallback (data URL or srcdoc instead of blob URL).
 * Set VITE_ANDROID_WIDGET_DATA_URL_FALLBACK=false at build time to disable (e.g. for A/B test or rollback).
 */
export function useAndroidHtmlFallback(): boolean {
  if (!isAndroidWebView()) { return false }
  const flag = import.meta.env.VITE_ANDROID_WIDGET_DATA_URL_FALLBACK
  return flag !== 'false'
}
